const LEFT = 'left';
const RIGHT = 'right';
const TOP = 'top';
const BOTTOM = 'bottom';

/**
 * Gets a neat string representation of an object's supported keys.
 * @param  {Object} object The object to parse.
 * @param  {String} name   The object's name.
 * @return {String}
 */
const getSupportedList = (object, name) => Object.keys(POSITIONS).map((position) => `${name}.${position}`).join(', ');

/**
 * All available tooltip positions.
 * @type {Object<String>}
 */
export const POSITIONS = {
    LEFT,
    RIGHT,
    TOP,
    BOTTOM,
    LEFT_TOP: 'left-top',
    LEFT_BOTTOM: 'left-bottom',
    RIGHT_TOP: 'right-top',
    RIGHT_BOTTOM: 'right-bottom',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right'
};

/**
 * All available positions' opposites.
 * @type {Object<String>}
 */
export const POSITIONS_OPPOSITES = {
    [LEFT]: RIGHT,
    [RIGHT]: LEFT,
    [TOP]: BOTTOM,
    [BOTTOM]: TOP
};

/**
 * All available popover trigger events.
 * @type {Object<String>}
 */
export const TRIGGERS = {
    CLICK: 'click',
    HOVER: 'hover'
};

/**
 * The error message thrown when trying to pass an unsupported position to the component.
 * @type {String}
 */
export const UNSUPPORTED_POSITION_ERROR = `Position passed is not a valid position. Valid positions include: ${getSupportedList(POSITIONS, 'POSITIONS')}`;

/**
 * The error message thrown when trying to pass an unsupported trigger to the component.
 * @type {String}
 */
export const UNSUPPORTED_TRIGGER_ERROR = `Trigger passed is not a valid trigger. Valid triggers include: ${getSupportedList(TRIGGERS, 'TRIGGERS')}`;

/**
 * The amount of time in miliseconds to wait before closing the popover when hovering out of it.
 * @type {Number}
 */
export const HOVER_TIMEOUT = 50;
